// extracted by mini-css-extract-plugin
export default {"NavigateGif":"NavigateGif_NavigateGif__6E0hd","Text":"NavigateGif_Text__wvO+0"};